module.exports = __webpack_public_path__ + "img/MASTER_CHN_VP_Handbook_Web6.c6e2a870.jpg";